export const getWallet = (state) => state.wallet.data;

export const getIsLoadingWallet = (state) => state.wallet.isLoading;

export const getSelectedWalletTitle = (state) => state.wallet.selectedTitle;
